/**
 * Canonical list of Indian States and Union Territories.
 * Mirrors the backend list in mostlyagent/api/utils/indian_states.py.
 */
export const INDIAN_STATES: { code: string; label: string }[] = [
  { code: 'AN', label: 'Andaman & Nicobar Islands' },
  { code: 'AP', label: 'Andhra Pradesh' },
  { code: 'AR', label: 'Arunachal Pradesh' },
  { code: 'AS', label: 'Assam' },
  { code: 'BR', label: 'Bihar' },
  { code: 'CH', label: 'Chandigarh' },
  { code: 'CT', label: 'Chhattisgarh' },
  { code: 'DD', label: 'Dadra & Nagar Haveli and Daman & Diu' },
  { code: 'DL', label: 'Delhi' },
  { code: 'GA', label: 'Goa' },
  { code: 'GJ', label: 'Gujarat' },
  { code: 'HP', label: 'Himachal Pradesh' },
  { code: 'HR', label: 'Haryana' },
  { code: 'JH', label: 'Jharkhand' },
  { code: 'JK', label: 'Jammu & Kashmir' },
  { code: 'KA', label: 'Karnataka' },
  { code: 'KL', label: 'Kerala' },
  { code: 'LA', label: 'Ladakh' },
  { code: 'MH', label: 'Maharashtra' },
  { code: 'ML', label: 'Meghalaya' },
  { code: 'MN', label: 'Manipur' },
  { code: 'MP', label: 'Madhya Pradesh' },
  { code: 'MZ', label: 'Mizoram' },
  { code: 'NL', label: 'Nagaland' },
  { code: 'OD', label: 'Odisha' },
  { code: 'PB', label: 'Punjab' },
  { code: 'PY', label: 'Puducherry' },
  { code: 'RJ', label: 'Rajasthan' },
  { code: 'SK', label: 'Sikkim' },
  { code: 'TN', label: 'Tamil Nadu' },
  { code: 'TS', label: 'Telangana' },
  { code: 'TR', label: 'Tripura' },
  { code: 'UK', label: 'Uttarakhand' },
  { code: 'UP', label: 'Uttar Pradesh' },
  { code: 'WB', label: 'West Bengal' },
];

/** Set of valid Indian state codes for quick lookup. */
export const VALID_STATE_CODES = new Set(INDIAN_STATES.map((s) => s.code));

/** Map from state code to human-readable name. */
export const STATE_CODE_TO_NAME: Record<string, string> = Object.fromEntries(
  INDIAN_STATES.map((s) => [s.code, s.label]),
);
